import type { Novidade } from './tipos';

/**
 * Fase 2, W25 (K21 e K14): lixeira nas telas que faltavam (funcionário, oportunidade, agendamento cancelado, contrato em
 * rascunho, curso, recurso, produto, trilha e motivo de perda) e, no Compras, as condições do fornecedor na ficha do Cadastros,
 * o cadastro rápido de serviço e de produto no item da compra e o recebimento sem o Estoque.
 */
export const novidadeLixeiraFornecedor: Novidade = {
  id: '2026-10-05-lixeira-fornecedor',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  rota: '/cadastros/cadastros/pessoas',
  textos: {
    pt: {
      titulo: 'Lixeira em mais telas e condições do fornecedor na ficha',
      resumo: 'Funcionário, oportunidade, agendamento, contrato e curso voltam da lixeira, e as condições de compra ficam na ficha.',
      passos: [
        'Funcionário cadastrado por engano, oportunidade aberta ou perdida e agendamento cancelado agora têm Excluir.',
        'O botão Lixeira de Pessoas, Pipeline, Agenda, Contratos, Cursos e Recursos desfaz a exclusão em até 30 dias.',
        'Na ficha do fornecedor, o cartão Condições de compra guarda condição, forma, prazo de entrega e pedido mínimo.',
        'A compra e o pedido novos partem dessas condições; no item da compra, Novo serviço e Novo produto cadastram na hora.',
        'Sem o Estoque instalado, o recebimento do pedido confirma e gera a conta a pagar, sem entrada no estoque.',
      ],
    },
    en: {
      titulo: 'Trash on more screens and supplier terms in the record',
      resumo: 'Employee, opportunity, appointment, contract and course come back from the trash, and purchase terms live in the record.',
      passos: [
        'An employee created by mistake, an open or lost opportunity and a canceled appointment now have Delete.',
        'The Trash button in People, Pipeline, Schedule, Contracts, Courses and Resources undoes the deletion within 30 days.',
        'In the supplier record, the Purchase terms card keeps payment terms, method, lead time and minimum order.',
        'New purchases and orders start from these terms; in the purchase item, New service and New product register on the spot.',
        'Without Inventory installed, receiving the order confirms it and creates the payable, with no stock entry.',
      ],
    },
    es: {
      titulo: 'Papelera en más pantallas y condiciones del proveedor en la ficha',
      resumo: 'Empleado, oportunidad, cita, contrato y curso vuelven de la papelera, y las condiciones de compra quedan en la ficha.',
      passos: [
        'El empleado registrado por error, la oportunidad abierta o perdida y la cita cancelada ahora tienen Eliminar.',
        'El botón Papelera de Personas, Pipeline, Agenda, Contratos, Cursos y Recursos deshace el borrado en hasta 30 días.',
        'En la ficha del proveedor, la tarjeta Condiciones de compra guarda condición, forma, plazo de entrega y pedido mínimo.',
        'La compra y el pedido nuevos parten de esas condiciones; en el ítem de la compra, Nuevo servicio y Nuevo producto registran al momento.',
        'Sin Inventario instalado, la recepción del pedido confirma y genera la cuenta por pagar, sin entrada en el stock.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-lixeira-fornecedor/lixeira.webp', null, '/novidades/2026-10-05-lixeira-fornecedor/condicoes.webp', '/novidades/2026-10-05-lixeira-fornecedor/item.webp', null],
  treinamento: { curso: 'novidades' },
};
